// ----------------------------------------------------------------------
// <copyright file="Izenda.ExportManager.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var ObservablePropTypes = require('mobx-react').propTypes;
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var Paginator = require('share/components/controls/DataGrid/helpers/Izenda.Paginator');
  var connect = require('share/enhancers/Izenda.Connect');
  var IconMenu = require('share/components/controls/Izenda.IconMenu');
  var Panel = require('share/components/controls/Izenda.Panel');
  var convertToDateTimeFormat = require('share/utils/Izenda.ConvertToDateTimeFormat');
  var uiState = require('logic/Izenda.UiState');
  var { Table, Column } = require('share/components/controls/DataGrid/Izenda.Table');
  var { TABLE_DEF, STATUS } = require('logic/data/Izenda.ExportManagerConstants');

  var ExportManager = React.createClass({
    propTypes: {
      store: ObservablePropTypes.observableObject.isRequired
    },

    componentDidMount: function(){
      this.props.store.loadExportQueueList();

      uiState.setOpenExportManagerStatus(false);
    },

    renderExportTable: function(){
      var store = this.props.store;
      var exportList = store.model.exportList;
      var exportPagingInfo = store.model.exportPagingInfo;
      var exportTotalRecords = store.model.exportTotalRecords;

      return (
        <Panel>
          <Table dataSource={exportList} minHeight={600} maxHeight={600}>
              <Column {...TABLE_DEF['name']} cell={this.renderNameCell} />
              <Column {...TABLE_DEF['fileType']} cell={this.renderTypeCell} />
              <Column {...TABLE_DEF['exportedDate']} cell={this.renderDateCell} />
              <Column {...TABLE_DEF['status']} cell={this.renderStausCell} />
              <Column {...TABLE_DEF['downloadFile']} cell={this.renderFileCell} />
          </Table>
          <Paginator
            onChange={this.goToPage}
            onDropdownChange={this.onPageSizeChange}
            totalRecords={exportTotalRecords}
            pageSize={exportPagingInfo.pageSize}
            pageIndex={exportPagingInfo.pageIndex}
          />
        </Panel>
      );
    },

    goToPage: function(pageIndex){
      var loader = this.props.loader;
      var store = this.props.store;

      loader.startLoading();
      return store.goToExportManagerPage(pageIndex).finally(loader.endLoading.bind(loader));
    },

    onPageSizeChange: function(pageSize){
      var loader = this.props.loader;
      var store = this.props.store;
      var exportPagingInfo = store.model.exportPagingInfo;

      loader.startLoading();
      exportPagingInfo.setPageSize(pageSize);
      return store.goToExportManagerPage(1).finally(loader.endLoading.bind(loader));
    },

    renderNameCell: function(item, key){
      return (<span>{item[key]}</span>);
    },

    renderTypeCell: function(item, key){
      return (<span>{item[key]}</span>);
    },

    renderDateCell: function(item, key){
      var date = convertToDateTimeFormat(uiState.currentUser.dateFormat, item[key]);
      return (<span>{date}</span>);
    },

    renderFileCell: function(item){
      var statusCode = item['status'];

      if(statusCode === 3 || statusCode === 4 || statusCode === 6){
        var store = this.props.store;
        var downloadFile = () => {
          store.downloadExportQueueFile(item);
        }
        return (<a onClick={downloadFile}><span className="icon-import"></span></a>);
      }

      return null;
    },

    renderStausCell: function(item, key){
      const getStatusInfoByCode = (code) => {
        switch(code){
          case 1:
          case 2:
            return STATUS.PENDING;
          case 3:
          case 4:
          case 6:
            return STATUS.COMPLETED;
          case 5:
          case 7:
            return STATUS.FAILED;
        }
      }

      var statusCode = item[key];
      var statusInfo = getStatusInfoByCode(statusCode);

      return (<span className={statusInfo.class}>{statusInfo.title}</span>);
    },

    render: function () {
      var store = this.props.store;
      var localization = this.props.localization;

      return (
        <div className="izenda-Wrapper izenda-UserProfile">
          <div className="izenda-Wrapper-header">
            <IconMenu />
            <div className='izenda-ActionBarLeft u_paddingTop'>
              <strong className='u_textUppercase'>{localization.getText('EXPORT_MANAGER_TITLE_MY_EXPORTS')}</strong>
            </div>
          </div>
          <div className="izenda-Wrapper-content">
            <ScrollBox>
              <div className="u_paddingLeftRight">
                {this.renderExportTable()}
              </div>
            </ScrollBox>
          </div>
        </div>
      );
    }
  });

  module.exports = connect()(ExportManager);
})();



// WEBPACK FOOTER //
// ./ui/modules/MyProfile/ExportManager/Izenda.ExportManager.jsx